import { render, staticRenderFns } from "./CreateStaffDialog.vue?vue&type=template&id=ba7e7e00&scoped=true&"
import script from "./CreateStaffDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateStaffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7e7e00",
  null
  
)

export default component.exports